/* ============================================================================
   OUR CORE PRODUCTS — Products - Carousel (D 4182:45153 · M 4182:45251), the
   Homepage / PDP product rail: the Homepage .pcard (Figma Product Tile
   242:33347 desktop / 242:33396 mobile) — photo, heart, name—colour, price.
   Five cards fill 1440 and the rail scrolls for the rest; at 390 the cards
   are 164 wide and carry the mobile tile's Quick Buy + (the PDP drawer, in
   the card's colour) and its image progress, as the PLP's picks carousel.
   Women's cards are Figma's; Men's follow the same top / pant pattern.
   Real names, prices, photos, sizes and fits: data/carousel.json
   (scripts/carousel-data.mjs, figs-product-data).
   ========================================================================== */

import { animate, hover, track, MO, state, play, tween, $, $$ } from '../10-pdp-prototype/mo.js';
import { announce } from '../10-pdp-prototype/ui.js';
import { CAROUSEL } from './data.js';
import { gender, onGender } from './gender.js';
import { openQuickBuy } from './quickbuy.js';

const rail = $('[data-pcard-rail]');
const money = (n) => `$${Number(n).toFixed(2)}`;
const list = () => CAROUSEL[gender()] || CAROUSEL.women || [];

function cardHTML(p) {
  const ext = /^https?:/.test(p.url);
  const label = `${p.name}—${p.colorName}`;
  return `
    <a class="pcard ncl-pcard" href="${p.url}"${ext ? ' target="_blank" rel="noopener"' : ''} data-pcard data-pid="${p.id}" draggable="false">
      <span class="pcard__media">
        <img class="pcard__img" src="${p.images[0]}" alt="${label}" loading="lazy" decoding="async" draggable="false" data-pcard-img>
        <button class="pcard__fav fav" type="button" aria-label="Save ${label}" aria-pressed="false" data-pcard-fav>
          <img class="fav__icon fav__icon--default" src="assets/ui/icon-heart-white.svg" alt="" width="20" height="20">
          <img class="fav__icon fav__icon--filled" src="assets/ui/icon-heart-filled.svg" alt="" width="20" height="20">
          <span class="fav__pulse" aria-hidden="true" data-fav-pulse></span>
        </button>
        <button class="ncl-pcard__qb" type="button" aria-label="Quick buy ${label}" aria-haspopup="dialog" data-pcard-qb>
          <img src="assets/ui/quick-buy-24.svg" alt="" width="24" height="24">
        </button>
        <span class="ncl-pcard__progress" aria-hidden="true">${p.images.map((_, k) => `<span class="ncl-pcard__dot${k ? '' : ' ncl-pcard__dot--on'}"></span>`).join('')}</span>
      </span>
      <span class="pcard__info">
        <span class="pcard__name">${label}</span>
        <span class="pcard__price">${money(p.price)}</span>
      </span>
    </a>`;
}

/* the Homepage tile's hover: the photo pushes in on --mo-slow */
let offs = [];
function bindCards() {
  offs.splice(0).forEach((off) => off?.());
  $$('[data-pcard]', rail).forEach((card) => {
    const img = $('[data-pcard-img]', card);
    offs.push(hover(card, () => {
      track(animate(img, { scale: MO.scaleHover }, { duration: MO.slow, ease: MO.eEntrance }));
      return () => track(animate(img, { scale: 1 }, { duration: MO.slow, ease: MO.eEntrance }));
    }));
  });
}

function render() {
  rail.innerHTML = list().map(cardHTML).join('');
  rail.scrollLeft = 0;
  bindCards();
}

export function initProducts() {
  render();
  /* one delegated listener each: the heart (the PDP's pulse) and the + */
  rail.addEventListener('click', (e) => {
    const fav = e.target.closest('[data-pcard-fav]');
    if (fav) {
      e.preventDefault(); e.stopPropagation();
      const saved = fav.getAttribute('aria-pressed') !== 'true';
      fav.setAttribute('aria-pressed', String(saved));
      if (saved) {
        if (!state.reduced) track(animate($('[data-fav-pulse]', fav), { scale: [0.8, 1.8], opacity: [0.45, 0] }, { duration: 0.6, ease: MO.eStandard }));
        announce('Product added to Favorites');
      }
      return;
    }
    const qb = e.target.closest('[data-pcard-qb]');
    if (qb) {
      e.preventDefault(); e.stopPropagation();
      const p = list().find((x) => x.id === qb.closest('[data-pcard]').dataset.pid);
      if (p) openQuickBuy(p, qb);
    }
  });
  /* the page's one Women / Men state: the section that was toggled swaps
     with the catalog's fade; any other just re-renders */
  onGender((g, source) => {
    const mine = source === $('[data-products]');
    if (!mine) { render(); $$('[data-pcard]', rail).forEach((c) => { c.style.opacity = '1'; }); return; }
    play($$('[data-pcard]', rail), { opacity: [1, 0] }, { duration: MO.quick, ease: MO.eExit })?.finished.then(() => {
      render();
      tween($$('[data-pcard]', rail), { opacity: [0, 1], y: [MO.riseSm, 0] }, { duration: MO.slow, ease: MO.eEntrance, delay: (i) => i * MO.stagTight });
    });
  });
}
